import React, { Fragment, useEffect, useState } from "react";

import { Col, Row, Flex } from "antd";

import Container from "@/components/container/Container";
import CardComponent from "@/components/card";

import { setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";

import "@/styles/dashboard/dashboard-documents.scss";
import IconUploadV2 from "@/components/icons/IconUploadV2";
import IconAttachment from "@/components/icons/IconAttachment";
import ButtonComponent from "@/components/button/Button";
import BackWithLabel from "@/components/common/BackWithLabel";
import { useDispatch } from "react-redux";
import { getFileCategories } from "@/services/common/getFileCategories";
import { getUserFileByCategory } from "@/services/users/getUserFileByCategory";
import { groupById } from "@/helpers";
import { uploadFile } from "@/services/users/uploadFile";

const DashboardDocuments = ({ isGuidePanel = false }) => {
  const dispatch = useDispatch();
  const [allDocuments, setAllDocuments] = useState([]);

  const fetchData = () => {
    getFileCategories()
      .then((res) => {
        console.log(res);
        const fileIds = res.map((x) => x.id);
        getUserFileByCategory(fileIds).then((files) => {
          groupById(files, "fileCategoryId").then((obj) => {
            const data = res.map((x) => {
              return {
                id: x.id,
                title: x.name,
                message: `Maximum number of documents allowed is (${x.limit})`,
                isRequired: false,
                limit: x.limit,
                files: obj[x.id]?.length ? obj[x.id] : [],
              };
            });
            setAllDocuments(data);
          });
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const openModal = (fileCategoryId, limit) => {
    // Compute remaining allowed files by subtracting already uploaded files.
    const doc = allDocuments.find((item) => item.id === fileCategoryId);
    const remainingLimit = doc ? limit - doc.files.length : limit;
    console.log({ limit, remainingLimit });
    dispatch(setCurrentForm("dashboardDocuments"));
    dispatch(setModalOpen(true));
    dispatch(
      setFormProps({
        onSubmit: (value) => {
          const files = [];
          if (value?.file?.length > 0) {
            const uploadPromises = value.file?.map(async (fileItem) => {
              const formData = new FormData();
              formData.append("file", fileItem.originFileObj);

              return uploadFile(fileCategoryId, formData)
                .then((res) => {
                  files.push(res);
                })
                .catch((err) => {
                  console.error(err);
                });
            });

            Promise.all(uploadPromises).then(() => {
              fetchData();
              dispatch(setModalOpen(false));
            });
            // Promise.all(uploadPromises).then(() => {
            //   const finalFormData = new FormData();
            //   console.log(files, "files");
            //   finalFormData.append("comment", value.documentName ?? "");
            //   finalFormData.append("files", JSON.stringify(files));

            //   submitStudentTaskDocumentById(fileCategoryId, finalFormData)
            //     .then((res) => {
            //       fetchData();
            //       dispatch(setModalOpen(false));
            //     })
            //     .catch((err) => console.log(err));
            // });
          } else {
            console.log("No files to upload");
          }

          // formData.append("fileCategoryId  ", value.documentType);
          // uploadFile(fileCategoryId, formData)
          //   .then((res) => {
          //     fetchData();
          //     dispatch(setModalOpen(false));
          //   })
          //   .catch((err) => console.log(err));
        },
        // Pass the remaining limit so that the UploadDocument component allows only the allowed number of files.
        limit: remainingLimit,
        fileCategoryId,
      })
    );
  };

  const handleViewDocument = (title, files) => {
    dispatch(setCurrentForm("viewDocument"));
    dispatch(setModalOpen(true));
    dispatch(
      setFormProps({
        title: title,
        files: files,
        fetchData: fetchData,
      })
    );
  };
  return (
    <Fragment>
      <div className="documents-wrapper">
        <Container>
          <div className="heading title-h5-1">
            <BackWithLabel path="/dashboard" label="Document" />
          </div>
          <div className="document-cards">
            <Row gutter={[16, 16]}>
              {allDocuments?.map((item, index) => {
                return (
                  <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24} key={index}>
                    <div className="document-card">
                      <CardComponent>
                        <div className="title body-b1">
                          {item.title}
                          {item.isRequired && <span className="required">*</span>}
                        </div>
                        <div className="message body-b3">{item.message}</div>
                        <ButtonComponent
                          className="upload-button body-b1-2"
                          onClick={() => openModal(item.id, item.limit)}
                          icon={<IconUploadV2 color="#fdfefe" />}
                          label="Upload Another File"
                          varient="primary"
                          gap={"0.5rem"}
                          data-item-limit={item.limit}
                          data-item-files={item?.files?.length}
                          disabled={
                            item.limit === item?.files?.length || item?.files?.length > item.limit
                          }
                        />
                        <div className="document-card-footer body-b3">
                          <Flex gap={"1rem"} align="center">
                            <IconAttachment />
                            <span>{`Uploaded files (${item?.files?.length}):`}</span>
                            {item?.files?.length ? (
                              <span
                                className="cursor-pointer color-brand"
                                onClick={() => handleViewDocument(item.title, item?.files)}
                              >
                                View Document
                              </span>
                            ) : (
                              <span>No Document</span>
                            )}
                          </Flex>
                        </div>
                      </CardComponent>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Container>
      </div>
    </Fragment>
  );
};

export default DashboardDocuments;
